/**
 * Finds the nearest field that remains in the active review list after the
 * current field falls out of it.
 *
 * This preserves the user's relative position in the review flow instead of
 * jumping back to the first field whenever a suggestion is resolved.
 *
 * @param {Object} params
 * @param {string[]} params.previousFieldIds Ordered field IDs before the mutation.
 * @param {string[]} params.nextFieldIds Ordered field IDs after the mutation.
 * @param {string|null} params.currentFieldId Field that was active when the mutation started.
 * @returns {string|null}
 */
export const findNearestRemainingReviewField = ({
  previousFieldIds = [],
  nextFieldIds = [],
  currentFieldId = null,
}) => {
  if (!currentFieldId || nextFieldIds.length === 0) return null;
  if (nextFieldIds.includes(currentFieldId)) return currentFieldId;

  const currentIndex = previousFieldIds.indexOf(currentFieldId);
  if (currentIndex === -1) {
    return nextFieldIds[0] || null;
  }

  for (let index = currentIndex + 1; index < previousFieldIds.length; index += 1) {
    const candidate = previousFieldIds[index];
    if (nextFieldIds.includes(candidate)) {
      return candidate;
    }
  }

  for (let index = currentIndex - 1; index >= 0; index -= 1) {
    const candidate = previousFieldIds[index];
    if (nextFieldIds.includes(candidate)) {
      return candidate;
    }
  }

  return nextFieldIds[0] || null;
};

export default findNearestRemainingReviewField;
